import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const Wrapper = styled.div`
    margin-bottom: ${token('space.300')};

    ul {
        padding-left: ${token('space.250')};
    }
`;

export const Title = styled.div`
    display: flex;
    align-items: center;
    margin-top: ${token('space.100')};
    font-weight: 600;
    cursor: pointer;
    user-select: none;

    span[role='img'] {
        margin-top: ${token('space.050')};
        margin-left: ${token('space.negative.100')};
    }
`;

export const ErrorsList = styled.ul`
    margin-top: ${token('space.200')};
    padding-left: ${token('space.100')} !important;
    list-style-type: none;

    span {
        margin-right: ${token('space.050')};
        font-size: 14px;
    }
`;
